import {
  ALLOWED_IMAGE_EXTENSIONS,
  ALLOWED_IMAGE_MIME_TYPES,
  MAX_IMAGE_FILE_SIZE_BYTES,
  type ImageValidationIssue
} from '../constants/uploadConstraints';

interface ValidationSuccess {
  ok: true;
}

interface ValidationFailure {
  ok: false;
  issue: ImageValidationIssue;
}

export type ImageValidationResult = ValidationSuccess | ValidationFailure;

function hasAllowedMimeType(file: File) {
  if (ALLOWED_IMAGE_MIME_TYPES.includes(file.type as (typeof ALLOWED_IMAGE_MIME_TYPES)[number])) {
    return true;
  }

  const extension = `.${file.name.split('.').pop()?.toLowerCase() ?? ''}`;
  return ALLOWED_IMAGE_EXTENSIONS.includes(
    extension as (typeof ALLOWED_IMAGE_EXTENSIONS)[number]
  );
}

export function validateImageFile(file: File): ImageValidationResult {
  if (!hasAllowedMimeType(file)) {
    return { ok: false, issue: 'type' };
  }

  if (file.size > MAX_IMAGE_FILE_SIZE_BYTES) {
    return { ok: false, issue: 'size' };
  }

  return { ok: true };
}
